<template>
  <div style="width: 70%; margin: 0 auto; margin-top: 2%">
    <el-form ref="form" label-width="120px">
      <el-form-item label="渠道">
        <channel-selector
          placeholder="请选择"
          @change="onChannelSelectorChange"
          ref="channelSelector"
        >
        </channel-selector>
      </el-form-item>
      <el-form-item v-if="form.selectedChannelId != ''">
        <div style="width: 600px">
          <el-tabs type="card" v-model="form.activeLanguageTabName">
            <el-tab-pane
              v-for="item in form.languageAnnouncements"
              :key="item.languageId"
              :name="item.languageId"
            >
              <span slot="label"
                ><i
                  v-if="item.title.trim() == ''"
                  class="el-icon-info"
                  style="margin-right: 5px; color: red"
                ></i
                >{{ `${item.languageName}` }}</span
              >
              <div>
                <label style="display: block">标题</label>
                <el-input
                  v-model="item.title"
                  :readonly="isViewMode"
                ></el-input>
              </div>
              <div style="margin-top: 5px">
                <label style="display: block">正文</label>
                <el-input
                  type="textarea"
                  rows="15"
                  v-model="item.content"
                  :readonly="isViewMode"
                ></el-input>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-form-item>
    </el-form>
    <div v-if="form.selectedChannelId != ''">
      <div v-if="isViewMode">
        <el-button
          type="primary"
          @click="startEdit()"
          icon="el-icon-edit"
          style="margin-left: 360px"
          >编辑</el-button
        >
      </div>
      <div style="margin-left: 320px" v-else>
        <el-button @click="cancelEdit()">取消</el-button>
        <el-button type="primary" @click="save()" style="margin-left: 50px"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      isViewMode: true, // 当前是否是在阅读模式（如果不是，那就是在编辑模式）
      form: {
        selectedChannelId: "", // 当前选择的渠道的id
        languageAnnouncements: [], // 各个语言的公告
        activeLanguageTabName: "",
      },
      availableLanguages: [], // 多语言集合
    };
  },

  components: {
    ChannelSelector,
  },

  async created() {
    // 查询多语言集合
    await this.getLanguageList();
  },

  watch: {
    /**
     * 切换了渠道
     */
    "form.selectedChannelId": {
      handler(newValue, oldValue) {
        this.onChangeChannel();
      },
    },
  },

  methods: {
    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.selectedChannelId = newChannelId;
    },

    /**
     * 切换了渠道
     */
    async onChangeChannel() {
      // 取消编辑模式
      await this.cancelEdit();
    },

    /**
     * 进入编辑模式
     */
    startEdit() {
      // 切换到编辑模式
      this.isViewMode = false;
    },

    /**
     * 取消编辑
     */
    async cancelEdit() {
      // 切换到阅读模式
      this.isViewMode = true;

      // 重新查询目标渠道的公告
      await this.getAnnouncementOfSelectedChannel();
    },

    /**
     * 保存公告
     */
    async save() {
      let languageAnnouncements = [];

      for (let e of this.form.languageAnnouncements) {
        languageAnnouncements.push({
          languageId: e.languageId,
          title: e.title,
          content: e.content,
        });
      }

      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/announcement/update`,
          {
            channelId: this.form.selectedChannelId,
            languageAnnouncements: languageAnnouncements,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 2004) {
          util.gotoLoginPage();
          return;
        }

        this.$message.error(resData.message);
        return;
      }

      this.$message.success("保存成功");

      // 切换到阅读模式
      this.isViewMode = true;
    },

    /**
     * 查询多语言集合
     */
    async getLanguageList() {
      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/language/getList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      if (resData.data.languages) {
        for (let l of resData.data.languages) {
          this.availableLanguages.push(l);
        }
      }
    },

    /**
     * 查询公告
     */
    async getAnnouncementOfSelectedChannel() {
      this.form.languageAnnouncements = [];

      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/announcement/get`,
          {
            channelId: this.form.selectedChannelId,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 2004) {
          util.gotoLoginPage();
          return;
        }

        this.$message.error(resData.message);
        return;
      }

      for (let l of this.availableLanguages) {
        let isExist = false;

        if (resData.data.languageAnnouncements) {
          for (let la of resData.data.languageAnnouncements) {
            if (la.languageId == l.id) {
              this.form.languageAnnouncements.push({
                languageId: la.languageId,
                languageName: l.name,
                title: la.title,
                content: la.content,
              });

              isExist = true;
            }
          }
        }

        if (!isExist) {
          this.form.languageAnnouncements.push({
            languageId: l.id,
            languageName: l.name,
            title: "",
            content: "",
          });
        }
      }

      if (
        this.form.languageAnnouncements &&
        this.form.languageAnnouncements.length > 0
      ) {
        this.form.activeLanguageTabName =
          this.form.languageAnnouncements[0].languageId;
      }
    },
  },
};
</script>

<style scoped>
</style>